<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5
                      class="mt-2"
                      @click="$refs['insufficient-funds'].show()"
                      v-text="Title"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div class="card mt-2">
            <div class="customer-info box-shadow">
              <div class="mt-4 d-flex align-items-center">
                <b-col md="9">
                  <p>
                    Keep a record of your cash movement for the current session.
                  </p>
                </b-col>
                <b-col md="3" class>
                  <div class="d-flex">
                    <b-button
                      variant="primary"
                      block
                      @click="cashBox('CASHIN')"
                      id="cash-in-btn"
                    >
                      Cash In
                      <!-- <img src="@/assets/images/add.svg" width="20" class="ml-2" /> -->
                    </b-button>
                    <b-button
                      variant="danger"
                      block
                      class="ml-3"
                      @click="cashBox('CASHOUT')"
                      id="cash-out-btn"
                    >
                      Cash Out
                      <!-- <img src="@/assets/images/remove-white.svg" class="ml-2" /> -->
                    </b-button>
                  </div>
                </b-col>
              </div>

              <div class="text-left pl-3 py-1 mt-4 activites-bar">
                Recent acitivities
              </div>

              <div class="cash-register-data">
                <div
                  class="cash-register-data d-flex align-items-center justify-content-center notification"
                  v-if="fetchedTransactions.length == 0 && !$loading"
                  style="height:100%"
                >
                  <p class="mb-0 text-muted">No activities found.</p>
                </div>
                <b-table
                  v-if="fetchedTransactions.length > 0"
                  ref="selectableTable"
                  selectable
                  :select-mode="selectMode"
                  selected-variant="active"
                  :fields="fields"
                  :items="fetchedTransactions"
                  responsive="sm"
                  class="cash-mangement-table"
                  fixed
                >
                  <template v-slot:cell(cash)="data">
                    <label
                      class="ml-3 mb-0"
                      :class="
                        data.item.transaction_type == 'Cash Out'
                          ? 'text-danger'
                          : 'text-primary'
                      "
                      v-text="data.item.transaction_type"
                    />
                    <p class="fw-normal mb-0 ml-3" v-text="data.item.amount" />
                  </template>
                  <template v-slot:cell(time)="data">
                    <label class="mb-0">Date/Time</label>
                    <p>
                      {{
                        (data.item.date + " " + data.item.time)
                          | moment(" DD MMM YYYY h:mm A")
                      }}
                    </p>
                  </template>
                  <template v-slot:cell(terminal)="data">
                    <label class="mb-0" v-if="data.item.source != ''"
                      >Source</label
                    >
                    <p
                      v-text="data.item.source != '' ? data.item.source : '-'"
                    />
                  </template>
                  <template v-slot:cell(cashier)="data">
                    <label class="mb-0">Cashier</label>
                    <p
                      v-text="
                        data.item.cashier_name != ''
                          ? data.item.cashier_name
                          : '-'
                      "
                    />
                  </template>
                  <template v-slot:cell(remark)="data">
                    <label class="mb-0">Remarks</label>
                    <p
                      v-text="data.item.remarks != '' ? data.item.remarks : '-'"
                    />
                  </template>
                  <template v-slot:cell(button)="data">
                    <div v-if="data.item.status == 'REQUEST'" class="d-flex">
                      <b-button
                        variant="primary"
                        id="approve-cash-mgmnt"
                        @click="approveDisapprove('APPROVED', data.item)"
                      >
                        Approve
                      </b-button>
                      <b-button
                        variant="danger"
                        class="ml-3"
                        @click="approveDisapprove('DISMISSED', data.item)"
                        id="dismiss-cash-mgmnt"
                      >
                        Dismiss
                      </b-button>
                    </div>
                    <!-- <div> -->
                    <b-row v-if="data.item.status == 'REQUESTED'">
                      <b-col md="4" class="p-0 d-flex align-items-center">
                        <p class="text-danger">
                          <span>
                            <font-awesome-icon
                              :icon="['fa', 'exclamation-circle']"
                            />
                          </span>
                          Pending
                        </p>
                      </b-col>
                      <b-col md="8" class="p-0">
                        <b-button
                          variant="danger"
                          class="ml-3"
                          @click="approveDisapprove('DISMISSED', data.item)"
                          id="withdraw-cash-mgmnt"
                        >
                          Withdraw
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row class="mt-3" v-if="data.item.status == 'APPROVED'">
                      <!-- <b-col md="12" class="p-0 mt-2"> -->
                      <p class="text-success">
                        <span>
                          <font-awesome-icon :icon="['fa', 'check-circle']" />
                        </span>
                        Request approved
                      </p>
                      <!-- </b-col> -->
                    </b-row>
                    <!-- </div> -->
                  </template>
                </b-table>
                <!-- <b-table
                  ref="transaction-history"
                  selected-variant="active"
                  :fields="fieldsTrans"
                  :items="transactionHistory"
                  responsive="sm"
                  v-if="transactionHistory.length > 0"
                  class="cash-mangement-table"
                >
                  <template v-slot:cell(cash)="data">
                    <span
                      class="ml-3"
                      :class="data.item.transaction_type == 'Cash Out'?'text-danger':'text-primary'"
                    >{{data.item.transaction_type}}</span>
                    <h5 class="fw-normal mb-0 ml-3">&#8377; {{data.item.amount}}</h5>
                  </template>
                  <template v-slot:cell(time)="data">
                    <label class="mb-0">Time</label>
                    <p>{{data.item.time}}</p>
                  </template>
                  <template v-slot:cell(terminal)="data">
                    <label class="mb-0">Source</label>
                    <p>{{data.item.source}}</p>
                  </template>
                  <template v-slot:cell(cashier)="data">
                    <label class="mb-0">Cashier</label>
                    <p>{{data.item.cashirename}}</p>
                  </template>
                  <template v-slot:cell(remark)="data">
                    <label class="mb-0">Remarks</label>
                    <p>{{data.item.remarks}}</p>
                  </template>
                </b-table>-->
                <!-- <div>
                  <b-row class="px-3 pt-1 pb-2">
                    <b-col md="2">
                      <span class="text-danger">Petty Cash Out</span>
                      <h5 class="fw-normal mb-0">100.00</h5>
                    </b-col>
                    <b-col md="2" class="text-left">
                      <label class="mb-0">Remark</label>
                      <p>Paid for tea</p>
                    </b-col>
                    <b-col md="3" class="text-left">
                      <label class="mb-0">Sent by</label>
                      <p>name of the cashier</p>
                    </b-col>
                    <b-col md="1" class="text-left">
                      <label class="mb-0">Time</label>
                      <p>14.20</p>
                    </b-col>
                    <b-col md="2" class="text-right">
                      <label class="mb-0">Terminal</label>
                      <p>Terminal name</p>
                    </b-col>
                    <b-col md="2" class="text-right">
                      <label class="mb-0">Cashier</label>
                      <p>James Buchanan Barnes</p>
                    </b-col>
                  </b-row>

                  <hr />
                </div>-->
              </div>
            </div>
            <div class="clearfix"></div>
          </div>

          <!-- Cash in modal-->
          <b-modal
            id="cash-box"
            :title="cashinout == 'CASHIN' ? 'Cash In' : 'Cash Out'"
            size="sm"
            centered
            modal-class="open-session"
            hide-footer
            style="padding: 0rem 1.5rem;"
            no-close-on-backdrop
            @close="onClose"
          >
            <b-form class="cash-modal" @submit.prevent>
              <b-row>
                <div class="w-100">
                  <b-col md="12" lg="12">
                    <label for class="mb-0" id="label-enter-amt"
                      >Enter amount</label
                    >
                    <b-form-group
                      id="group-enter-amount"
                      class="total-amount my-2 mx-auto"
                    >
                      <b-form-input
                        id="input-enter-amount"
                        type="number"
                        v-model="amount"
                        size="lg"
                        autofocus
                        class="w-100"
                        onkeypress="if(this.value.length==6 && Number(event.key)<=9) return false;"
                        placeholder="0.00"
                      />
                    </b-form-group>
                    <label
                      for
                      class="mb-2"
                      v-show="!isHidden"
                      id="label-select-type"
                      >Select type</label
                    >
                    <select
                      class="form-control pl-2 mb-2"
                      v-show="!isHidden"
                      @change="cashPointType($event)"
                      :disabled="amount == ''"
                      :style="amount == '' ? 'cursor: no-drop' : ''"
                      id="select-select-type"
                    >
                      <option
                        v-for="item in cashPoint"
                        :key="item.cash_point_type_name"
                        :value="item.cash_point_type_id"
                        v-text="item.cash_point_type_name"
                        :id="item.cash_point_type_id"
                      />
                      <option value selected disabled>Select your type</option>
                      <!-- <option value>Option Two</option> -->
                    </select>
                    <label
                      for
                      class="mb-0"
                      v-if="cashPointListShow"
                      id="label-terminal-name"
                      >Terminal name</label
                    >
                    <select
                      class="form-control pl-2"
                      v-show="!isHidden"
                      @change="cashPointCashier($event)"
                      v-if="cashPointListShow"
                      :disabled="amount == ''"
                      :style="amount == '' ? 'cursor: no-drop' : ''"
                      id="select-terminal-name"
                    >
                      <option
                        v-for="item in cashPointList"
                        :key="item.cash_point_name"
                        :value="item.id"
                        v-text="item.cash_point_name"
                        :id="item.cash_point_name"
                      />
                      <option value :selected="cashPointName == ''" disabled
                        >Select your type</option
                      >
                      <!-- <option value>Option Two</option> -->
                    </select>
                    <div v-if="cashPointName != '' && cashierName != ''">
                      <label for class="mb-0" id="label-cashier-name"
                        >Cashier Name</label
                      >
                      <b-form-input
                        type="text"
                        class="mt-2"
                        disabled
                        v-model="cashierName"
                        id="input-cashier-nmae"
                      />
                    </div>
                    <label for class="mb-2 mt-2" id="label-remark"
                      >Remarks</label
                    >
                    <b-form-textarea
                      id="input-remark"
                      placeholder="Add remark..."
                      v-model="remarks"
                    />
                  </b-col>
                </div>
                <b-col md="12">
                  <footer class="mt-4">
                    <b-row>
                      <b-col md="6">
                        <!-- <div class="custom-check">
                          <input
                            class="pull-right"
                            type="checkbox"
                            id="cashin"
                            v-on:click="isHidden = !isHidden"
                          />
                          <label for="cashin">&nbsp; &nbsp;Petty Cash In</label>
                        </div>-->
                      </b-col>
                      <b-col md="6">
                        <b-button
                          type="submit"
                          :disabled="
                            btnDisabled || amount == 0 || amount == '0'
                          "
                          variant="primary"
                          class="float-right"
                          @click="cashInReq"
                          id="cash-mngmnt-cont"
                        >
                          <span v-if="!$loading">Continue</span>
                          <b-spinner small v-if="$loading" />
                        </b-button>
                      </b-col>
                    </b-row>
                  </footer>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
          <b-modal
            id="insufficient-funds"
            ref="insufficient-funds"
            size="sm"
            centered
            hide-header
            hide-footer
            style="padding: 0rem 1.5rem;"
            no-close-on-backdrop
            no-close-on-esc
            @close="onClose"
          >
            <h6 style="font-weight: normal">
              <span class="text-danger">
                <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
              </span>
              Insufficient Funds
            </h6>
            <p>
              This terminal does not have sufficient funds to perform this
              action.
            </p>
            <b-row class="float-right">
              <b-button
                @click="closeInsufficientFunds"
                id="insufficient-dismiss"
                >Dismiss</b-button
              >
            </b-row>
          </b-modal>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";

export default {
  name: "cash-management",
  components: {
    Dashboard,
    Loading,
  },
  mounted() {
    // this.fetchInvoiceHistory();
    this.fetchCurrentTransactions();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    cashPointList() {
      let data = [];
      if (this.pointType == 1) {
        this.cashPointListing.map((item) => {
          if (item.cashiredetails.is_session_active == "1") data.push(item);
        });
      } else if (this.pointType != 1) {
        this.cashPointListing.map((item) => {
          data.push(item);
        });
      }
      return data;
    },
    btnDisabled() {
      if (this.amount != "") {
        if (this.pointType != "") {
          if (this.cashPointName != "") {
            return false;
          }
        }
      }
      return true;
    },
    storeCashLimit() {
      return this.state.system.settings.cashmanagement_limit.options[0]
        .store_cash.type;
    },
  },

  data() {
    return {
      Title: "Cash Management",
      loading: true,
      remarks: "",
      isHidden: false,
      cashPoint: [],
      pointType: "",
      cashPointListing: [],
      fetchedTransactions: [],
      // transactionHistory: [],
      cashPointListShow: false,
      amount: "",
      cashPointName: "",
      cashinout: "",
      approveDismiss: "",
      fields: [
        { key: "cash", label: "" },
        { key: "time", label: "" },
        { key: "terminal", label: "" },
        { key: "cashier", label: "" },
        { key: "remark", label: "" },
        { key: "button", label: "", class: "w-15" },
      ],
      // fieldsTrans: [
      //   { key: "cash", label: "", class: "w-20" },
      //   { key: "time", label: "" },
      //   { key: "terminal", label: "", class: "w-20" },
      //   { key: "cashier", label: "" },
      //   { key: "remark", label: "", class: "w-25" }
      //   // { key: "button", label: "", class: "w-20" }
      // ],
      selectMode: "single",
      cashierName: "",
      cashPointTypeName: "",
    };
  },
  methods: {
    closeInsufficientFunds() {
      this.$refs["insufficient-funds"].hide();
    },
    onClose() {
      this.cashPointListShow = false;
      this.cashPoint = [];
      this.pointType = "";
      this.cashPointListing = [];
      this.remarks = "";
      this.amount = "";
      this.cashPointName = "";
      this.cashierName = "";
      this.cashPointTypeName = "";
    },
    // onRowSelected(items) {
    //   items.map(id => {
    //     this.selected = id.id;
    //   });
    //   console.log(this.selected);
    // },
    cashPointType(event) {
      this.cashPointName = "";
      this.cashierName = "";
      this.cashPointTypeName = "";
      this.pointType = event.target.value;
      // console.log(this.pointType);
      this.cashPointListShow = true;
      for (var i = 0; i < this.cashPoint.length; i++) {
        if (this.cashPoint[i].cash_point_type_id == this.pointType) {
          this.cashPointTypeName = this.cashPoint[i].cash_point_type_name;
          this.cashPointListing = this.cashPoint[i].cash_point_list;
          // console.log(this.cashPointListing);
        }
      }
    },
    cashPointCashier(event) {
      this.cashPointName = event.target.value;
      this.cashPointList.map((item) => {
        if (this.cashPointName == item.id) {
          if (
            item.hasOwnProperty("cashiredetails") &&
            item.cashiredetails.hasOwnProperty("cashirename")
          )
            this.cashierName = item.cashiredetails.cashirename;
        }
      });
    },
    cashBox(inout) {
      this.cashinout = inout;
      this.$loading = true;
      let postData = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/cash-point-type",
      };
      axios
        .post(postData.url, postData)
        .then((response) => {
          this.$loading = false;
          this.cashPoint = response.data.data.cash_point_type;
          // console.log(this.cashPoint);
          this.$bvModal.show("cash-box");
        })
        .catch(() => (this.$loading = false));
    },
    cashInReq() {
      if (this.cashPointTypeName == "Store-Cash") {
        if (parseFloat(this.storeCashLimit) < parseFloat(this.amount)) {
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", {
            message: `${msg.STORE_CASH_THRESHOLD} ${
              this.currencySymbol
            }${parseFloat(this.storeCashLimit).toFixed(2)} only.`,
            type: "danger",
          });
          return;
        }
      }
      this.$loading = true;
      let postData = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        // udidtoken: this.state.trans_from,
        cash_trans_type: this.cashinout,
        cash_point_type_id: this.pointType,
        cash_point_id: this.cashPointName,
        amount: this.amount,
        terminal_id: this.state.system.settings.terminal_id,
        remarks: this.remarks,
        url: "/cash-point-transfer",
      };
      axios
        .post(postData.url, postData)
        .then((response) => {
          if (
            response.data.status == "fail" &&
            response.data.type == "insufficient funds"
          ) {
            this.$refs["insufficient-funds"].show();
          } else {
            let alertData = {
              message: msg.CASH_MANAGEMENT_REQ,
              type: "success",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }

          this.$loading = false;
          this.fetchCurrentTransactions();
          // console.log(response);
        })
        .catch(() => (this.$loading = false));
      this.onClose();
      this.$bvModal.hide("cash-box");
    },
    fetchCurrentTransactions() {
      this.$loading = true;
      let postData = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        trans_from: this.state.system.trans_from,
        vu_id: this.state.sessions.user.vu_id,
        store_id: this.state.sessions.user.store_id,
        terminal_id: this.state.system.settings.terminal_id,
        // udidtoken: this.state.trans_from,
        url: "/cash-transaction-history",
      };
      axios
        .post(postData.url, postData)
        .then((response) => {
          this.fetchedTransactions = response.data.data;
          // console.log(this.fetchedTransactions);
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    approveDisapprove(approveDismiss, item) {
      this.selected = item.id;
      // console.log(item);
      this.approveDismiss = approveDismiss;
      // console.log(this.approveDismiss);
      this.$loading = true;
      let postData = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        trans_from: this.state.system.trans_from,
        vu_id: this.state.sessions.user.vu_id,
        store_id: this.state.sessions.user.store_id,
        // udidtoken: this.state.trans_from,
        status: this.approveDismiss,
        transaction_id: this.selected,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/update-transaction-status",
      };
      axios
        .post(postData.url, postData)
        .then((response) => {
          if (approveDismiss == "APPROVED") {
            if (
              response.data.status == "fail" &&
              response.data.type == "insufficient funds"
            ) {
              this.$refs["insufficient-funds"].show();
            } else {
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", {
                message:
                  msg.APPROVED_DISMISSED +
                  " " +
                  this.approveDismiss.toLowerCase(),
                type: "success",
              });
            }
          } else {
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message:
                msg.APPROVED_DISMISSED +
                " " +
                this.approveDismiss.toLowerCase(),
              type: "success",
            });
          }
          this.fetchCurrentTransactions();
          // this.transHistory();
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    // transHistory() {
    //   this.$loading = true;
    //   let postData = {
    //     api_token: this.state.token,
    //     v_id: this.state.user.v_id,
    //     trans_from: this.state.trans_from,
    //     vu_id: this.state.user.id,
    //     store_id: this.state.user.store_id,
    //     udidtoken: this.state.trans_from
    //   };
    //   axios
    //     .post("/cash-transaction-history", postData)
    //     .then(response => {
    //       this.transactionHistory = response.data.data;
    //       console.log(this.transactionHistory);
    //       this.$loading = false;
    //     })
    //     .catch(err => {
    //       this.$loading = false;
    //     });
    // }
  },
};
</script>
<style lang="scss" scoped>
.theme-dark .customer-info {
  background-color: #202020 !important;
  .custom-select {
    border: none !important;
  }
}

.theme-dark {
  .cash-register-data {
    h5 {
      color: $white-color;
    }
  }
}
.btn-success.disabled,
.btn-success:disabled {
  background: #808080;
  border-color: #808080;
}

.grey-outline-btn {
  border: 1px #808080 solid;
  color: #fff;
  background: #808080;
  width: 120px;
}
.grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.custom-select {
  font-size: 13px;
}
.cash-register-data {
  height: calc(100vh - 186px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
  .table thead {
    display: none;
  }
  h5 {
    color: $body-color;
    font-size: 17px;
    margin-top: 4px;
  }
}

h5 {
  color: $mid-grey;
}

.remark-wrap {
  @include text-overflow();
}
</style>
